import { render, staticRenderFns } from "./Bodies.vue?vue&type=template&id=20dac2e4&"
import script from "./Bodies.vue?vue&type=script&lang=js&"
export * from "./Bodies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports